module.exports = "/images/hexagon-yellow.png?67dfccbe5025b5b208b36b267b867bc6";